import { useEffect, useState } from 'react';
import { fetchInsurers } from '../../providers/insurers';
import { Input, Select } from '../Field';
import { MinusCircleIcon } from '@heroicons/react/solid';

function InsurersTab({ insurers: clinicInsurers, t }) {
    const [insurers, setInsurers] = useState([]);
    const [available, setAvailable] = useState([]);
    const [selected, setSelected] = useState(clinicInsurers || []);

    const removeHandler = (index) => {
        setSelected((oldValue) => {
            const newValue = [...oldValue];
            newValue.splice(index, 1);
            return newValue;
        });
    };

    const selectHandler = (e) => {
        const { id, name } = insurers.find(({ id }) => id == e.target.value);
        setSelected((oldValue) => [...oldValue, { id, name }].sort((a, b) => a.name.localeCompare(b.name)));
    };

    useEffect(() => {
        fetchInsurers().then(setInsurers);
    }, []);

    useEffect(() => {
        setSelected(clinicInsurers || []);
    }, [clinicInsurers]);

    useEffect(() => {
        const selectedIds = selected.map((insurer) => insurer.id);
        setAvailable(insurers.filter(({ id }) => !selectedIds.includes(id)));
    }, [insurers, selected]);

    return (
        <div className="space-y-2">
            {selected.length ? (
                <div className="overflow-hidden border border-gray-300 rounded-md shadow-sm">
                    <table className="w-full">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="px-4 py-2 font-medium text-left">{t('insurers')}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y">
                            {selected.map(({ id, name }, index) => (
                                <tr key={index}>
                                    <td className="px-4 py-2">{name}</td>
                                    <td className="w-0 text-xs text-right">
                                        <input type="hidden" name="insurers[]" value={id} />
                                        <button
                                            type="button"
                                            className="px-4 text-gray-500 hover:text-gray-800"
                                            onClick={() => {
                                                removeHandler(index);
                                            }}
                                        >
                                            <MinusCircleIcon className="relative top-[1px] h-5 w-5" />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : (
                <>
                    <input type="hidden" name="insurers[]" />
                    <div className="text-gray-500">- {t('no-insurers')}</div>
                </>
            )}

            <div className="w-72">
                <Select placeholder={t('add-insurer') + '...'} options={available} onChange={selectHandler} />
            </div>
        </div>
    );
}

export default InsurersTab;
